import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { SmileIcon, CircleDotIcon, HeartIcon, ArmchairIcon, TargetIcon } from 'lucide-react';
const areas = [{
  name: 'FACE',
  icon: SmileIcon,
  description: 'SkinTyte can benefit the face by tightening and firming loose skin, reducing the appearance of fine lines and wrinkles, and improving overall skin tone and texture. It can help lift sagging cheeks, define the jawline, and reduce nasolabial folds for a more youthful appearance.'
}, {
  name: 'NECK',
  icon: CircleDotIcon,
  description: "SkinTyte treatments can help tighten loose skin on the neck, reducing the appearance of neck bands, creases, and wrinkles. It can also improve the definition of the jawline and reduce the appearance of a 'turkey neck' or sagging skin under the chin."
}, {
  name: 'CHEST',
  icon: HeartIcon,
  description: 'SkinTyte can be used to tighten and firm the skin on the chest area, reducing the appearance of wrinkles, creases, and sagging skin. It can help improve the texture and tone of the skin, restoring a more youthful appearance to the décolletage.'
}, {
  name: 'ARMS',
  icon: ArmchairIcon,
  description: "SkinTyte treatments can target loose or sagging skin on the upper arms, often referred to as 'bat wings.' It can help tighten and firm the skin in this area, reducing the appearance of flabbiness and improving arm contour."
}, {
  name: 'ABDOMEN',
  icon: TargetIcon,
  description: 'SkinTyte can benefit the abdomen by tightening loose or sagging skin, particularly after weight loss or pregnancy. It can help improve abdominal contour, reduce the appearance of stretch marks, and create a firmer, more toned appearance.'
}];
export function STTreatmentAreas() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-2038">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-2039">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-2040">
          <h2 className="text-[28px] lg:text-[44px] uppercase text-black leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-2041">
            TREATMENT AREAS
          </h2>

          <p className="font-serif italic text-[#333333] text-[17px] leading-[1.7] max-w-[700px] mb-6" data-id="element-2042">
            SkinTyte can be used on various areas of the body where mild laxity
            or sagging skin is a concern. Some common target areas include:
          </p>

          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-2043"></div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6" data-id="element-2044">
          {areas.map((area, index) => <AnimateOnScroll key={index} delay={index * 80} data-id="element-2045">
              <div className="bg-white p-8 shadow-[0_4px_16px_rgba(0,0,0,0.06)] h-full text-center group hover:shadow-[0_8px_24px_rgba(0,0,0,0.1)] transition-shadow duration-300" data-id="element-2046">
                <area.icon size={40} strokeWidth={1.5} className="text-[#FF1493] mx-auto mb-4 group-hover:scale-110 transition-transform duration-300" data-id="element-2047" />
                <h3 className="text-black text-lg font-bold font-[Poppins,_sans-serif] mb-3 uppercase" data-id="element-2048">
                  {area.name}
                </h3>
                <p className="text-[#666666] text-sm leading-[1.6] font-body" data-id="element-2049">
                  {area.description}
                </p>
              </div>
            </AnimateOnScroll>)}
        </div>
      </div>
    </section>;
}